import React from 'react';

import classNames from 'classnames';

import Paragraph from '@/components/Elements/Paragraph/Paragraph';

import { PortfolioParagraphContentProps } from '@/helpers/getParagraphForDynamicPage';

import Quotes from '@/icons/quotes.svg';

import './Quote.scss';

interface QuoteProps extends PortfolioParagraphContentProps {
  text: string;
  author: string;
  position?: string;
  isGraySection?: boolean;
}

export const Quote = ({ text, author, position, isGraySection }: QuoteProps) => (
  <div className="Quote_wrapper">
    <div className={classNames('Quote_container', { 'background-white': isGraySection })}>
      <div>
        <Quotes />
        <Paragraph paragraphClass="body-1 Quote_block-text" item={text} />
      </div>
      <div className="Quote_author-container">
        <Paragraph paragraphClass="body-2 Quote_author" item={author} />
        {position && <Paragraph paragraphClass="body-3 Quote_position" item={position} />}
      </div>
    </div>
  </div>
);
